import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

import {FuseConfigService} from '@fuse/services/config.service';
import {fuseAnimations} from '@fuse/animations';
import {Router} from '@angular/router';
import {AccountService} from 'app/core/auth/account.service';
import {ToastrService} from 'ngx-toastr';

/**
 * Problem types whose server-supplied message is safe and useful to show as-is:
 * the account has no email address on file, or the reset allowance has been used up.
 */
const REPORTABLE_PROBLEM_TYPES = ['https://www.jhipster.tech/problem/email-not-found', 'https://www.jhipster.tech/problem/too-many-requests'];

@Component({
    selector: 'forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class ForgotPasswordComponent implements OnInit {
    forgotPasswordForm: UntypedFormGroup;
    isSubmitting = false;

    /**
     * Constructor
     *
     * @param {Router} router
     * @param _toast
     * @param accountService
     * @param {UntypedFormBuilder} _formBuilder
     * @param {FuseConfigService} _fuseConfigService
     */
    constructor(
        private router: Router,
        private _toast: ToastrService,
        private accountService: AccountService,
        private _formBuilder: UntypedFormBuilder,
        private _fuseConfigService: FuseConfigService
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.forgotPasswordForm = this._formBuilder.group({
            username: ['', [Validators.required]],
            tenant: ['', [Validators.required]]
        });
    }

    /**
     * Send a password reset link to the email address registered against the username
     */
    // tslint:disable-next-line:typedef
    sendActivationLink() {
        if (this.forgotPasswordForm.invalid || this.isSubmitting) {
            return;
        }

        this.isSubmitting = true;
        this.accountService.requestPasswordReset(this.forgotPasswordForm.value.username, this.forgotPasswordForm.value.tenant).subscribe(
            () => {
                this.isSubmitting = false;
                // Deliberately neutral: the API does not disclose whether the account exists.
                this._toast.info('If the account exists, a password reset link has been sent to its registered email address');
                this.router.navigate(['/login']);
            },
            (err) => {
                this.isSubmitting = false;
                if (REPORTABLE_PROBLEM_TYPES.includes(err?.error?.type)) {
                    this._toast.error(err.error.title);
                } else {
                    this._toast.error('The password reset request could not be completed. Please try again later.');
                }
            }
        );
    }
}
